export default __webpack_public_path__ + "static/media/Cls3.6b5f280d.png";